module.exports = function(users) {
	'use strict'
	users.directive('userEditDir',userEditDir);
	userEditDir.$inject=['getDataService','$rootScope','API_URL','$http','cleanObj','alertService','$state','serverError','aiModalService','refreshtokenService'];
	function userEditDir(getDataService,$rootScope,API_URL,$http, cleanObj, alertService,$state,serverError,aiModalService,refreshtokenService) {
		return {
			restrict: 'E',
			template: require('./partial/edituser.html'),
			link: function(scope, ele, $attrs, ctrl) {
				scope.parent = scope.$eval($attrs.parent);
  				scope.roles = scope.parent.roles;
			    scope.userId = scope.parent.userId;
			    scope.firstnameRequired = false;
			    scope.lastnameRequired = false;
			    scope.passwordWeakRequired = false;
			    scope.matchedpassword = false;
			    scope.passwordWeak = false;
			    scope.passwordStrong = false;
			    scope.passwordChecked = false;
				scope.selectedPosition = {value:'Novinar'}
			    $rootScope.hasLoaded = true;
				scope.functionalityList = [];
			    scope.checkPassword = function(pass) {
			      if(pass) {
			        scope.checkPasswordObj = owasp.test(pass);
			        if(scope.checkPasswordObj.strong == false) {
			          scope.passwordWeak = true;
			          scope.passwordStrong = false;
			          scope.passwordChecked = false;
			        } else {
			          scope.passwordStrong = true;
			          scope.passwordWeak = false;
			          scope.passwordChecked = true;
			        }
			        
			      }
			    }
			    if(scope.userId) {
			    	var getUserFunction = function() {
				      	getDataService.get({param1:'users', param2: scope.userId}).$promise.then(function(dataUser){
				         	scope.dataUser = dataUser;
							scope.selectedPosition.value = (scope.dataUser.position)? scope.dataUser.position:'none'  
				    		scope.selectedRole = {value:scope.dataUser.role._id};
				    		var statusString = scope.dataUser.status.toString();
				    		scope.selectedStatus ={value:statusString};
							aiModalService.get('functionality-list', function(data) {
								if(data.results && data.results.length > 0) {
									scope.functionalityList = data.results.map(function(item) {
										return {
											_id: item,
											name: item.split('-').join(' '),
											checked: scope.dataUser.aitools.includes(item)
										}
									});
								}
							});
				        }, function(error){
				          	if(error.status ==401) {
					            var promise = refreshtokenService.getAccessToken();
					            promise.then(
					              function(answer) {
					             	if(answer=200) {
					             		getUserFunction();
					             	}
					              },
					              function(error) {
					   
					              },
					              function(progress) {
					               // report progress
					            });
				          	} else if(error.status ==502) {
                				serverError()
              			    } else {
					          	scope.parent.editUserShow= false;
								scope.userId = null;
					            $state.transitionTo('app.allusers', {id: null}, {
					              location: true,
					              inherit: true,
					              relative: $state.$current,
					              notify: false
					            });
					        }
				        });
			    	} 
					getUserFunction();
					if(!scope.roles) {
						var getUsersFunction = function() {
							getDataService.get({param1:'users', param2: 'roles', param3:null}).$promise.then(function(data){
								scope.roles = data.roles;
							}, function(error){
							  if(!window.navigator.onLine) {
								offlineError()
								$rootScope.hasLoaded = true;
								return
							  }
							  if(error.status == 401) {
								var promise = refreshtokenService.getAccessToken();
								promise.then(
								function(answer) {
								  if(answer==200) {
									getUsersFunction();
								  }
								  // do something
								},
								function(error) {
								  // report something
								},
								function(progress) {
								 // report progress
								});
							  }else if(error.status ==502) {
								serverError();
							  } else {
								alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
							  }  
							});
						}
						getUsersFunction()
					}  
			    }
			    var updateUserFunction = function(url) {
					var aitools = scope.functionalityList.filter(function(item) {
						return item.checked;
					}).map(function(item) {
						return item._id;
					});
					var updateDataUser = {
						'email': scope.dataUser.email,
		                'password': scope.password,
		                'first_name': scope.dataUser.first_name,
		                'last_name' : scope.dataUser.last_name,
		                'role' : scope.selectedRole.value,
		                'status' : parseInt(scope.selectedStatus.value),
						'position': (scope.selectedPosition.value !='none')? scope.selectedPosition.value:'',
						'bio': scope.dataUser.bio,
        				'social': scope.dataUser.social,
						'aitools': aitools,
						'gemini_api_key': scope.dataUser.gemini_api_key
					}
					cleanObj.clean(updateDataUser);
					var putFunction = function() {
						$http.put(url , updateDataUser)
				        .success(function (data, status, headers) {
				            alertService('success','Success ', data.message, 2000);
				        })
				        .error(function (data, status, header, config) {
				          	if(status ==401) {
				            var promise = refreshtokenService.getAccessToken();
				            promise.then(
				              	function(answer) {
					                if(answer==200) {   
					                  putFunction();
					                }
				              	},
				              	function(error) {
				              	},
				              	function(progress) {
				               // report progress
				            	});
				          	} else if(error.status ==502) {
                				serverError()
              				}else {  
					            alertService('danger','Opps! ', data.error.message);
				            
				          	}
				        });
					}
					putFunction();
			    }
			    scope.updateUser = function() {
			      var validation = true;
			      
			      if(!scope.dataUser.first_name) {
			        validation = false;
			        scope.firstnameRequired = true;
			      } else {
			        scope.firstnameRequired = false;
			      }
			      if(!scope.dataUser.last_name) {
			        validation = false;
			        scope.lastnameRequired = true;
			      } else {
			        scope.lastnameRequired = false;
			      }
			      if(scope.password) {
			        if(!scope.passwordChecked) {
			        	validation = false;
			        	scope.passwordWeakRequired = true;
			      	} else {
			        	scope.passwordWeakRequired = false;
			      	}
			      	if(!scope.repeatedpassword) {
				        validation = false;
				        scope.repeatpasswordRequired = true; 
			      	} else {
			        	scope.repeatpasswordRequired = false; 
			      	}
			      	if(scope.repeatedpassword != scope.password) {
			        	validation = false;
			        	scope.matchedpassword = true;
			      	} else {
			        	scope.matchedpassword = false;
			      	}
			      }
			      
			      if(validation) {
			        updateUserFunction(API_URL+ "users/"+scope.userId);
			      }
			    }
				$rootScope.closeEditUser = function() {
					$rootScope.ngEscapeAttrsParametars = [];
					scope.parent.editUserShow= false;
					scope.userId = null;
		            $state.transitionTo('app.allusers', {id: null}, {
		              location: true,
		              inherit: true,
		              relative: $state.$current,
		              notify: false
		            });
				}
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/usersModule/allusers/js/directive/userEditDirective.js
// module id = 634
// module chunks = 0